// Очередь баннеров главной, подборок и скролл-баннеров ведёт бэкенд
export const FIXED_POSITION_HINT =
  'Новый элемент встаёт первым, а дважды в сутки, в 06:00 и 18:00 МСК, порядок сдвигается по кругу: последний становится первым, первый — вторым. С галочкой элемент остаётся на своём месте. Порядок меняется перетаскиванием за ☰ в списке.'

export const LOCKED_ROW_HINT = 'Закреплён «Не перемешивать» — чтобы переставить, снимите галочку'
